module.exports = __webpack_public_path__ + "static/media/non-productive-icon.66e7c38a.png";